import axios from "axios";
import store from "./store/index";
import Vue from "vue";
import {
  PANELS,
  PANEL_API_URL,
  getActivePanelFromStorage,
} from "./config/panels";
export const isTest = false;
export const URL = isTest
  ? "http://localhost:3075/api"
  : "https://dod.seniorapp.pl/api";

// https://s2.seniorapp.pl
// https://s3.seniorapp.pl
// http://localhost:8443
// http://77.55.214.241:9091

const instance = axios.create({
  baseURL: URL,
});

const requestsWithoutLoaderIcon = [
  "/api/profile/needVerification",
  "/api/chat/unreadChatsNumber",
  "/api/adminTask/todo/amount",
  "/api/withdraw/waitingPaymentsNumber",
  "/api/profile/triedToLogInNumber",
];
let requestCounter = 0;
instance.interceptors.request.use(
  // Return a successful response back to the calling service
  (request) => {
    // Dynamiczny baseURL: domyslnie backend DOD (URL powyzej - zrodlo prawdy),
    // a dla panelu POD nadpisujemy na backend POD.
    const panel = getActivePanelFromStorage();
    if (panel === PANELS.POD) {
      request.baseURL = PANEL_API_URL[PANELS.POD];
    }
    let errorInRequest = null;
    try {
      if (request.data && request.data.entries()) {
        for (const pair of request.data.entries()) {
          if (pair[1] && pair[1].size && pair[1].size > 10000000) {
            Vue.notify({
              group: "error",
              text:
                "Rozmiar pliku jest za duży. Maksymalny rozmiar pliku to 10MB",
            });
            return;
          }
        }
      }
    } catch (error) {
      errorInRequest = error;
      request.errorInRequest = errorInRequest;
    }

    request.headers.common[
      "Authorization"
    ] = `Bearer ${window.localStorage.getItem("SAtoken")}`;

    if (
      request.url.split("pl/")[0] &&
      requestsWithoutLoaderIcon.includes(request.url.split("pl/")[0])
    ) {
      return request;
    }
    if (document.getElementsByClassName("loader")[0]) {
      document
        .getElementsByClassName("loader")[0]
        .classList.add("visibleLoader");
    }
    requestCounter++;
    return request;
  },
);

instance.interceptors.response.use(
  (response) => {
    // Return a successful response back to the calling service
    requestCounter--;
    if (requestCounter === 0) {
      if (document.getElementsByClassName("loader")[0]) {
        document
          .getElementsByClassName("loader")[0]
          .classList.remove("visibleLoader");
      }
    }
    // A successful DOD response means access is back (e.g. a manager re-granted it).
    // Re-enable the module and refresh the panel role so the DOD switch + admin
    // features return automatically - no page refresh needed. The background
    // notifications poll provides this signal within its interval.
    if (store.getters.getDodAccessRevoked) {
      store.commit("SET_DOD_ACCESS_REVOKED", false);
      store.dispatch("fetchMyPanelRole");
    } else if (store.getters.getToken && store.getters.getMyPanelRole === null) {
      // Rola rozliczeniowa pobierana jest raz przy logowaniu; jesli tamten strzal sie nie
      // udal (transient przy zimnym starcie backendu / wyczyszczenie przez chwilowy 403),
      // rola zostawala null i przyciski administratora byly zablokowane az do relogu.
      // Dociagamy ja przy pierwszym udanym callu DOD - `/me` zawsze zwraca ADMINISTRATOR|
      // PRACOWNIK, wiec null oznacza wylacznie nieudane pobranie, a ponowienie jest bezpieczne
      // (i self-limitujace: po udanym /me rola przestaje byc null). Poll powiadomien (co 10s)
      // gwarantuje ten sygnal nawet bez akcji uzytkownika.
      store.dispatch("fetchMyPanelRole");
    }
    return response;
  },
  (error) => {
    // Pobierania typu blob (PDF/XLSX): backend zwraca JSON z bledem w blobie,
    // np. POD przy braku szablonu (BadRequestException z nazwa brakujacego pliku).
    // Odczytujemy komunikat i pokazujemy go adminowi (zamiast cichego console.log w akcji).
    if (error.response && error.response.data instanceof Blob) {
      requestCounter--;
      if (
        requestCounter === 0 &&
        document.getElementsByClassName("loader")[0]
      ) {
        document
          .getElementsByClassName("loader")[0]
          .classList.remove("visibleLoader");
      }
      return error.response.data.text().then((text) => {
        let message = "Nie udało się wygenerować dokumentu";
        try {
          const parsed = JSON.parse(text);
          message = parsed.message || parsed.error || message;
        } catch (e) {
          if (text) message = text;
        }
        Vue.notify({ group: "error", text: message });
        return Promise.reject(error);
      });
    }
    // Brak odpowiedzi (blad sieci / CSP / timeout) - error.response undefined, nie ma czego parsowac.
    if (!error.response) {
      requestCounter--;
      if (
        requestCounter === 0 &&
        document.getElementsByClassName("loader")[0]
      ) {
        document
          .getElementsByClassName("loader")[0]
          .classList.remove("visibleLoader");
      }
      return Promise.reject(error);
    }
    if (
      error.response &&
      error.response.status &&
      error.response.status === 403
    ) {
      const data = error.response.data || {};
      if (data.message === "DOD_ACCESS_REVOKED") {
        // DOD panel access was revoked by a manager. This is a SHARED admin panel
        // (the main SeniorApp app fires DOD calls in the background), so a full
        // logout would lock the user out of everything. Just disable the DOD module
        // and keep the main session. The handler decides whether to notify + bounce
        // (only when the user is actively on a DOD route) vs. silently disable (a
        // background poll, e.g. at login) - so no toast pops up outside DOD.
        store.dispatch("handleDodAccessRevoked");
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
      Vue.notify({
        group: "error",
        text: "Nie posiadasz wymaganych uprawnień",
      });
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.status &&
      error.response.data.status !== 401
    ) {
      requestCounter--;
      if (requestCounter === 0) {
        if (document.getElementsByClassName("loader")[0]) {
          document
            .getElementsByClassName("loader")[0]
            .classList.remove("visibleLoader");
        }
      }
      return new Promise((resolve, reject) => {
        reject(error);
      });
    } else if (error.response.data.status == 401) {
      requestCounter--;
      if (requestCounter === 0) {
        if (document.getElementsByClassName("loader")[0]) {
          document
            .getElementsByClassName("loader")[0]
            .classList.remove("visibleLoader");
        }
      }

      store.dispatch("logout");
    } else if (error.response.data.status == 401) {
      requestCounter--;
      if (requestCounter === 0) {
        if (document.getElementsByClassName("loader")[0]) {
          document
            .getElementsByClassName("loader")[0]
            .classList.remove("visibleLoader");
        }
      }

      store.dispatch("logout");
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  },
);

export default instance;
